import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Edit a mission role's name / MD envelope / TJM. */
export function EditRoleDialog({ roleEdit, onChange, onClose, onSave, currency, isForfait, canViewFinance = true }) {
  // Iter-208 — `canViewFinance` defaults to true to preserve existing call sites;
  // MissionDetail passes the real flag so non-finance viewers can still rename
  // a role or adjust its JH envelope but never see/edit the TJM.
  const showTjm = !isForfait && canViewFinance;
  return (
    <Dialog open={!!roleEdit} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="edit-role-dialog">
        <DialogHeader>
          <DialogTitle>Edit role</DialogTitle>
          <DialogDescription>
            {isForfait ? "Edit the name or MD envelope of the role." : "Edit the name, MD envelope or TJM of the role."}
          </DialogDescription>
        </DialogHeader>
        {roleEdit && (
          <div className="space-y-4 py-2">
            <div>
              <Label>Role name</Label>
              <Input data-testid="edit-role-name" value={roleEdit.name} onChange={(e) => onChange({ ...roleEdit, name: e.target.value })} />
            </div>
            <div className={`grid grid-cols-1 ${showTjm ? "sm:grid-cols-2" : ""} gap-3`}>
              <div>
                <Label>Budget (JH)</Label>
                <Input data-testid="edit-role-jh" type="number" step="0.5" min="0" value={roleEdit.budget_jh} onChange={(e) => onChange({ ...roleEdit, budget_jh: e.target.value })} />
              </div>
              {showTjm && (
                <div>
                  <Label>TJM ({currency})</Label>
                  <Input data-testid="edit-role-tjm" type="number" step="50" min="0" value={roleEdit.tjm} onChange={(e) => onChange({ ...roleEdit, tjm: e.target.value })} />
                </div>
              )}
            </div>
          </div>
        )}
        <DialogFooter>
          <button onClick={onClose} className="px-4 h-10 text-sm hover:bg-zinc-100 rounded-md">Cancel</button>
          <button onClick={onSave} data-testid="edit-role-save" className="px-4 h-10 bg-zinc-950 text-white text-sm rounded-md hover:bg-zinc-800">Save</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}


/** Edit a single user assignment under a role (allocated MD + start date). */
export function EditAssignmentDialog({ assignEdit, onChange, onClose, onSave }) {
  return (
    <Dialog open={!!assignEdit} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="edit-assign-dialog">
        <DialogHeader>
          <DialogTitle>Éditer l'assignation — {assignEdit?.user_name}</DialogTitle>
          <DialogDescription>Adjust allocated MD or start date.</DialogDescription>
        </DialogHeader>
        {assignEdit && (
          <div className="space-y-4 py-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <Label>Budget (JH)</Label>
                <Input data-testid="edit-assign-jh" type="number" step="0.5" min="0" value={assignEdit.budget_jh} onChange={(e) => onChange({ ...assignEdit, budget_jh: e.target.value })} />
              </div>
              <div>
                <Label>Start date</Label>
                <Input data-testid="edit-assign-date" type="date" value={assignEdit.start_date} onChange={(e) => onChange({ ...assignEdit, start_date: e.target.value })} />
              </div>
            </div>
          </div>
        )}
        <DialogFooter>
          <button onClick={onClose} className="px-4 h-10 text-sm hover:bg-zinc-100 rounded-md">Cancel</button>
          <button onClick={onSave} data-testid="edit-assign-save" className="px-4 h-10 bg-zinc-950 text-white text-sm rounded-md hover:bg-zinc-800">Save</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
